import React from "react";
import AnyQuestions from "../../reusable/AnyQuestions";
import DatePicker from "react-datepicker";
import moment from "moment";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setRedirectPath } from "../../modules/actions/authActions";
import { getCart } from "../../modules/actions/cartActions";
import { getRentProduct } from "../../modules/actions/productActions";
import { getStoreAddresses } from "../../modules/actions/storeAddressActions";

import { addToCart } from "../../modules/actions/cartActions";
import { addFlashMessage } from "../../modules/actions/flashMessages.js";
import "react-datepicker/dist/react-datepicker.css";
import Validator from "validator";
import NotificationAlert from "react-notification-alert";
import { isEmpty, isNull } from "lodash";
import { Link, withRouter } from "react-router-dom";
import qs from "qs";
import Modal from "react-bootstrap/es/Modal";
import GoogleMapStores from "./GoogleMapStores";



// const shippingFee = 16;

function validateInput(data) {
  let errors = {};
  if (isNull(data.startDate)) {
    errors.startDate = "Please enter rental start date";
  }
  if (isNull(data.endDate)) {
    errors.endDate = "Please enter rental end date";
  }
  if (isNull(data.useType)) {
    errors.useType = "Please select where  you want to use";
  }
  if (Validator.isEmpty(data.receiveType)) {
    errors.receiveType = "Please enter required fields";
  }
  if (Validator.isEmpty(data.returnType)) {
    errors.returnType = "Please enter required fields";
  }
  if (!data.isAgree) {
    errors.isAgree = "Please accept the lost/damaged device agreement";
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
}

class RentCart extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      useType: null,
      receiveType: "DELIVERY",
      returnType: "Mail",
      quantity: 1,
      errors: {},
      days: 0,
      dropAddress: 0,
      isLoading: false,
      isAgree: false,
      shipping : {},
      pickupAddressInfo : {},
      dropoffAddressInfo : {},
      show: false,
      showLoc : false
    };
    this.days = 0;
    this.updateState = false;

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.handleShow2 = this.handleShow2.bind(this);
    this.handleClose2 = this.handleClose2.bind(this);
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleClose2() {
    this.setState({ showLoc: false });
  }

  handleShow2() {
    this.setState({ showLoc: true });
  }

  componentDidMount() {
    this.props.getStoreAddresses();
    this.props.getRentProduct();
    let payload = {
      sessionId: localStorage.getItem("sessionId")
    };
    // this.props.getCart(payload);
    console.log("props",this.props)
  }

  toggleChange = () => {
    this.setState({
      isAgree: !this.state.isAgree
    });
  };

  componentWillMount() {
    const qsParsed = qs.parse(
        this.context.router.history.location.search.slice(1)
    );

    if (qsParsed.login) {
      this.props
          .addToCart(this.props.auth.redirectPayload)
          .then(data => {
            console.log(data);
            if (data.status) {
              this.context.router.history.push({
                pathname: "/checkout",
                state : {
                  product : this.props.auth.redirectPayload.product
                }
              });
            } else {
              this.refs.notify.notificationAlert({
                place: "bl",
                message: (
                    <div>
                      <div>
                        <b>{data.message}</b>
                      </div>
                    </div>
                ),
                type: "danger",
                icon: "now-ui-icons ui-1_bell-53",
                autoDismiss: 7
              });
            }
          })
          .catch(error => {
            this.refs.notify.notificationAlert({
              place: "bl",
              message: (
                  <div>
                    <div>
                      <b>{error.response.data.message}</b>
                    </div>
                  </div>
              ),
              type: "danger",
              icon: "now-ui-icons ui-1_bell-53",
              autoDismiss: 7
            });
          });
    }
  }
  componentWillReceiveProps(nextProps) {

    if (!this.updateState) {
      console.log("===============================================");
      console.log(nextProps);
      this.updateState = true;
      if (!isEmpty(nextProps.storeAddress)) {

        this.setState({
          ...this.state,
          storeAddress : nextProps.storeAddress,
          pickupAddressInfo : nextProps.storeAddress[0],
          pickupAddress : nextProps.storeAddress[0]._id,
          dropAddress : nextProps.storeAddress[0]._id,
          dropoffAddressInfo : nextProps.storeAddress[0]
        });

      }

      if (!isEmpty(nextProps.cart.cart) && nextProps.cart.cart.product.type === 'rent') {

        let {startDate, endDate, useType, receiveType, returnType} = nextProps.cart.cart;

        startDate = moment(startDate);
        endDate = moment(endDate);

        if (typeof nextProps.cart.cart.shippingDetails !== 'undefined' && !isEmpty(this.state.storeAddress) && receiveType == "PICKUP") {

          let {pickupAddress, dropAddress} = nextProps.cart.cart.shippingDetails;

          var address1 = this.getAddressFiltered(this.state.storeAddress, pickupAddress);
          var address2 = this.getAddressFiltered(this.state.storeAddress, dropAddress);

          this.setState({
            startDate: startDate,
            endDate: endDate,
            useType: useType,
            receiveType: receiveType,
            returnType: returnType,
            dropAddress: dropAddress,
            pickupAddress: pickupAddress,
            pickupAddressInfo: address1,
            dropoffAddressInfo: address2
          });
          //this.setState({ ...this.state, useType, receiveType, returnType, dropAddress, pickupAddress, pickupAddressInfo : address1, dropoffAddressInfo : address2 });
        } else {
          this.setState({
            startDate: startDate,
            endDate: endDate,
            useType: useType,
            receiveType: receiveType,
            returnType: returnType
          });
          //this.setState({ ...this.state, useType, receiveType, returnType });
        }
      }
    }
  }

  isValid() {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }
  _handleStartChange = date => {
    if (this.state.endDate) {
      const start = moment(date);
      const end = moment(this.state.endDate);
      const days = end.diff(start, "days");
      if (days > 4) {
        this.setState({
          startDate: date
        });
      }
    } else {
      this.setState({
        startDate: date
      });
    }
  };

  _handleEndChange = date => {
    if (this.state.startDate) {
      this.setState({
        endDate: date
      });
    }
  };

  _onChange = event => {
    const field = event.target.name;
    const value = event.target.value;
    switch (field) {
      case "receiveType":
        this.setState({
          receiveType: value
        });

        break;
      case "returnType":
        this.setState({
          returnType: value
        });
        break;

      case "useType":
        this.setState({
          useType: value
        });
        break;
      default:
        this.setState({ [field]: value });
    }
  };

  _getSubTotal = (fraction = 2) => {
    let total = 0;
    const { startDate, endDate, useType } = this.state;

    if (startDate && endDate && useType) {
      const start = moment(startDate);
      const end = moment(endDate);
      const days = end.diff(start, "days") + 1;
      this.days = days;

      //console.log("===DAYS:" + days);

      if (useType === "USA") {
        total = days * this.props.product.product.domesticPrice;
      }
      if (useType === "GLOBAL") {
        total = days * this.props.product.product.globalPrice;
      }
    }
    return total.toFixed(fraction);
  };

  calculateDeliveryCharges(receiveType){
    let price = 0;
    if(receiveType == "DELIVERY"){
      price = 10;
    }

    if (receiveType == "PICKUP"){
      price = 5;
    }
    return price;
  }

  calculateReturnCharges(returnType){
    let price = 0;
    if(returnType == "Mail"){
      price = 10;
    }

    if (returnType == "DROPOFF"){
      price = 5;
    }
    return price;
  }

  getCalculatedShipping = () => {
    let deliveryCharges = this.calculateDeliveryCharges(this.state.receiveType);
    let returnCharges = this.calculateReturnCharges(this.state.returnType);
    return parseFloat(deliveryCharges) + parseFloat(returnCharges);
  };

  getTotal = () => {
    //flat shipping charge
    let subTotal = this._getSubTotal();
    if (subTotal > 0) {
      subTotal = parseFloat(subTotal);

      return subTotal + this.getCalculatedShipping();
    }
    return 0;
  };

  _handleAddTocart = () => {
    if (this.isValid()) {
      this.setState({ errors: {}, isLoading: true });

      const { auth, product } = this.props;
      const sessionId = localStorage.getItem("sessionId");
      const productId = product.product._id;
      const subtotal = this._getSubTotal();
      const total = this.getTotal();
      const shippingFee = this.getCalculatedShipping();
      const shippingDetails = {
        pickupAddress: this.state.pickupAddress,
        dropAddress: this.state.dropAddress
      };

      const {
        startDate,
        endDate,
        useType,
        receiveType,
        returnType,
        quantity,
        isAgree
      } = this.state;
      let payload = {
        startDate,
        endDate,
        useType,
        receiveType,
        returnType,
        quantity,
        sessionId,
        total,
        subtotal,
        shippingFee,
        productId,
        cartType: "rent",
        product: product.product,
        shippingDetails : shippingDetails
      };
      this.performCartAction(payload);
    }
  };

  _onPickupChange = event => {
    const field = event.target.name;
    const value = event.target.value;
    this.setState({
      [field]: value,
      pickupAddressInfo : this.getAddressById(value)
    });
  };

  _onDropoffChange = event => {
    const field = event.target.name;
    const value = event.target.value;
    this.setState({
      [field]: value,
      dropoffAddressInfo : this.getAddressById(value)
    });
  };

  getAddressFiltered(stores, id){
    var address = stores.find((address) => {
      return id === address._id
    });
    return address;
  };

  getAddressById(id){
    var address = this.props.storeAddress.find((address) => {
      return id === address._id
    });
    return address;
  }


  performCartAction(payload){

    const { auth } = this.props;

    if (auth.isAuthenticated) {
      this.props
          .addToCart(payload)
          .then(data => {
            console.log(data);
            if (data.status) {
              this.context.router.history.push({
                pathname : "/checkout",
                params: {
                  product : payload.product
                }
              });
            } else {
              this.showMessage(data.message);
            }
          })
          .catch(error => {
            this.showMessage(error.response.data.message);
          });
    } else {
      this.props.setRedirectPath("/checkout", payload);
      this.props.history.push({
        pathname : "/login",
        params : {
          product : payload.product,
          cart : payload,
        }
      });
    }
  }

  showMessage(message){
    this.refs.notify.notificationAlert({
      place: "bl",
      message: (
          <div>
            <div>
              <b>{message}</b>
            </div>
          </div>
      ),
      type: "danger",
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 7
    });
  };

  render() {
    const { errors } = this.state;
    //console.log(errors);
    return (

        <section className="BodyContainer AddQAContainer">
          <div className="container">
            <div className="row position-relative">

              <div className="col-md-5 services_img_bg">
                <div className="col-lg-12">
                  <div className="m-product-title">
                    MightyWifi <span className="Serif">Rent</span>
                  </div>
                </div>
                <img src="/images/mightywifi-cloud-1.jpg" alt="Mightywifi US and Global hotspot wifi device" />
                <div style={{clear:"both"}}></div>
                <a href="/images/mightywifi-cloud-1.jpg" className="device-link-thumb" data-lightbox="image-1">
                  <img src="/images/mightywifi-cloud-1.jpg" className="device-thumb" style={{marginTop:"10px"}} alt="Mightywifi US and Global hotspot wifi device front image" />
                </a>
                <a href="/images/mightywifi-cloud-2.jpg" className="device-link-thumb" data-lightbox="image-2">
                  <img src="/images/mightywifi-cloud-2.jpg" className="device-thumb" style={{marginTop:"10px"}} alt="Mightywifi US and Global hotspot wifi device side image" />
                </a>
                <a href="/images/mightywifi-cloud-3.jpg" className="device-link-thumb" data-lightbox="image-3">
                  <img src="/images/mightywifi-cloud-3.jpg" className="device-thumb" style={{marginTop:"10px"}} alt="Mightywifi US and Global hotspot wifi device with case image" />
                </a>
                <a href="/images/mightywifi-cloud-4.jpg" className="device-link-thumb" data-lightbox="image-6">
                  <img src="/images/mightywifi-cloud-4.jpg" className="device-thumb" style={{marginTop:"10px"}} alt="Mightywifi US and Global hotspot wifi device wall charger image" />
                </a>
              </div>

              <div className="col-md-7 rent_services_clip pt-d-5p">
                <div className="services_bg_pad">
                  <div className="row justify-content-center">
                    <div className="col-lg-12">
                      <div className="services_boxes mt-3 rounded p-4">
                        <div className="services_content mt-3">
                          <NotificationAlert ref="notify" />
                          <p className="mb-0 mt-2">
                            {/*The MightyWifi mobile hotspot allows users to instantly and securely connect up to 10 devices optimally to a local cellular network via its cloud SIM technology. The MightyWifi works in over 150 countries at 4G LTE speeds. We offer a range of plans to best match your needs.*/}
                            {/*If you travel overseas more than once, please consider purchasing the device
                            &nbsp;<a href="/buy/device" className="btn2 btn-orange">BUY</a>*/}
                            &nbsp;
                          </p>
                          <div style={{clear:"both",height:"30px"}}></div>

                          <h5 className="mb-10">
                            Where to :
                          </h5>
                          <p className="mb-0 mt-2 radio-toolbar">
                            <div className="row">
                              <div className="col-6" style={{paddingRight: 0}}>
                                <input
                                    id="USARent"
                                    type="radio"
                                    name="useType"
                                    value="USA"
                                    onChange={this._onChange.bind(this)}
                                    checked={this.state.useType === "USA"}
                                />{" "}
                                <label htmlFor="USARent">
                                  <b>USA</b> (${this.props.product.product.domesticPrice} / Day)<br/>
                                  <span style={{fontSize: "1rem"}}>High speed data limit is 1 GB / day</span>
                                </label>
                              </div>
                              <div className="col-6" style={{paddingRight: 0}}>
                                <input
                                    id="GrobalRent"
                                    type="radio"
                                    name="useType"
                                    value="GLOBAL"
                                    onChange={this._onChange.bind(this)}
                                    checked={this.state.useType === "GLOBAL"}
                                />{" "}
                                <label htmlFor="GrobalRent">
                                  <b>Global</b> (${this.props.product.product.globalPrice} / Day)<br/>
                                  <span style={{fontSize: "1rem"}}>High speed data limit is 0.5 GB / day</span>
                                </label>
                              </div>
                            </div>
                          </p>
                          {errors.useType && (
                              <span className="error-color-rent">
                            {errors.useType}
                          </span>
                          )}

                          <div style={{ clear: "both", height: "30px" }} />

                          <h5 className="mb-0">
                            Rental Period:
                          </h5>
                          <div className="row">
                            <div className="col-md-6 pr-0">
                              <div className="form-group mt-3">
                                <DatePicker
                                    className="form-control line-input"
                                    selected={this.state.startDate}
                                    minDate={moment().add(7, "days")}
                                    onChange={this._handleStartChange}
                                    placeholderText="Select Start Date"
                                    onChangeRaw={event => {
                                      event.preventDefault();
                                    }}
                                />
                                {errors.startDate && (
                                    <span className="error-color-rent">
                                  {errors.startDate}
                                </span>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 pr-0">
                              <div className="form-group mt-3">
                                <DatePicker
                                    className="form-control line-input"
                                    minDate={moment(this.state.startDate).add(
                                        0,
                                        "days"
                                    )}
                                    selected={this.state.endDate}
                                    onChange={this._handleEndChange}
                                    placeholderText="Select End Date"
                                    onChangeRaw={event => {
                                      event.preventDefault();
                                    }}
                                />
                                {errors.endDate && (
                                    <span className="error-color-rent">
                                  {errors.endDate}
                                </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <small className="mb-0 mt-0">
                            *Please allow 5 business days for processing and transit times
                          </small>
                          <div style={{ clear: "both", height: "30px" }} />

                          <div className="mb-0">
                            <h3 className="SansSerif bold600">
                              ${this._getSubTotal(0)} <span className="RentDate">/ {(this.state.endDate) ? this.state.endDate.diff(this.state.startDate, "days") + 1 : "0" }{" "}Days{" "} <span className="autocapitalize">{this.state.useType}</span></span>
                              <span className="RentDate m-break"> + Shipping and return fee (<span className="bold600">${this.getCalculatedShipping()}</span>)</span>
                            </h3>

                          </div>

                          <div style={{ clear: "both", height: "30px" }} />
                        </div>


                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12 desktop-view">
                <div style={{ clear: "both", height: "40px" }} />
                {/* <div className="line dark"></div> */}
              </div>

              <div className="col-md-12">
                {this.getTotal() > 0 ? (
                    <div>
                      {/*<div style={{ clear: "both", height: "15px" }} />*/}
                      {/*<p className="mb-0 mt-0">*/}
                      {/*"Rent for {this.days} days” and the $*/}
                      {/*{this.getTotal()} amount for the cost*/}
                      {/*</p>*/}
                      <div style={{ clear: "both", height: "15px" }} />
                      <small className="mb-0 mt-2">
                        <input
                            id="RentNotice"
                            type="checkbox"
                            checked={this.state.isAgree}
                            onChange={this.toggleChange}
                        />{" "}
                        <label className="display-contents" for="RentNotice">I acknowledge that I am responsible for the cost of the device in the event that it gets lost or damaged, as per the Terms and Conditions.</label>
                      </small>
                      {errors.isAgree && (
                          <span className="error-color-rent">
                  {errors.isAgree}
                </span>
                      )}
                      <div style={{ clear: "both", height: "15px" }} />

                    </div>
                ) : null}
              </div>

              <div className="col-md-10">
                <h2 className="mb-0 SansSerif bold100">
                  YOUR TOTAL IS <span className="bold700">${this.getTotal()}</span>
                </h2>
              </div>

              <div className="col-md-2 text-right">
                <a href="javascript:void(0)" onClick={this._handleAddTocart} className="btn btn-orange">Continue</a>
              </div>

              <div className="desktop-view" style={{ clear: "both", height: "150px" }} />
              <div className="mobile-view" style={{ clear: "both", height: "100px" }} />

              {/*<div className="col-md-12">
                <div class="line"></div>
                <h3 class="sub no-margin bold100 mb-3 SansSerif text-center">Limited Time Promotion</h3>
                <div className="row">
                  <div className="col-md-6">
                    <div className="promotion mb-4 text-center promoitem p-5">
                      <p class="promo-label">LIMITED TIME</p>
                      <p className="promo-title SansSerif">MightyWifi CLOUD <br/><span className="bold100">w/ 50GB US data &<br/>3GB Global data</span></p>
                      <p className="promo-price">
                        <span className="promo-discount-price mr-1">$210</span> <span className="promo-org-price mr-2 point-blue">$169</span>
                      </p>
                      <span><a href="/sale" className="btn">See more</a></span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="promotion mb-4 text-center promoitem p-5">
                      <p class="promo-label">LIMITED TIME</p>
                      <p className="promo-title SansSerif">MightyWifi CLOUD <br/><span className="bold100">w/ 3GB US data OR<br/>3GB Global data</span></p>
                      <p className="promo-price">
                        <span className="promo-discount-price mr-11px">$160</span> <span className="promo-org-price mr-2 point-blue">$129</span>
                      </p>
                      <span><a href="/sale" className="btn">See more</a></span>
                    </div>
                  </div>
                </div>
              </div>*/}

            </div>
          </div>
        </section>
    );
  }
}

RentCart.contextTypes = {
  router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
    product: state.product,
    cart: state.cart,
    storeAddress : state.storeAddress.storeAddress
  };
}

export default withRouter(connect(
    mapStateToProps,
    { getStoreAddresses, getRentProduct, addToCart, addFlashMessage, setRedirectPath, getCart }
)(RentCart));



// WEBPACK FOOTER //
// ./src/pages/rent/RentCart.js